/* eslint-disable linebreak-style */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import './index.css';
import { DefaultMessageThreadExample } from './App';
import { NotificationContainer } from './Components/NotificationApi';
import { AuthProvider, getMsalConfig } from './Components/Auth';
import { LoggerProvider, AggregatedLoggerBuilder } from './Components/Logger';
import { LLMSettingProvider } from './Components/Contexts';
import { TestSettingProvider } from './Test/TestSettingContext';
import { PlaygroundThemeProvider } from './Theme';

initializeIcons();

const logger = new AggregatedLoggerBuilder()
  .withConsoleLogger()
  .withAriaLogger({
    instrumentationKey: process.env.REACT_APP_ARIA_INGESTION_KEY,
    applicationName: 'ConvAdsPrototype',
    appendedData: {},
  })
  .build();
const authConfig = getMsalConfig(logger);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <BrowserRouter>
    <LoggerProvider value={logger}>
      <NotificationContainer>
        <AuthProvider
          authConfig={authConfig}
          scopes={process.env.REACT_APP_SCOPES?.split('+') || []}
        >
          <LLMSettingProvider>
            <TestSettingProvider>
              <PlaygroundThemeProvider>
                <DefaultMessageThreadExample />
              </PlaygroundThemeProvider>
            </TestSettingProvider>
          </LLMSettingProvider>
        </AuthProvider>
      </NotificationContainer>
    </LoggerProvider>
  </BrowserRouter>,
);
